import { render, staticRenderFns } from "./ConnectedFarm.vue?vue&type=template&id=b5442686"
import script from "./ConnectedFarm.vue?vue&type=script&lang=js"
export * from "./ConnectedFarm.vue?vue&type=script&lang=js"
import style0 from "./ConnectedFarm.vue?vue&type=style&index=0&id=b5442686&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports